import { KPITileItem } from 'types/pricingSimulator';
import KPITile from './KpiTile';

type KPITileProps = {
    tiles: KPITileItem[];
    onTileRemove: (kpiId: number) => void;
    loading: boolean;
    showKpiPercentage: boolean;
    kpiTileCharLimit: number;
    decimalForNonPercentage: number;
    decimalForPercentage: number;
};

// when loading using dummy values to loading tiles
const emptyLoadingTiles = Array.from({ length: 5 }, () => ({
    absChange: 0,
    id: 0,
    label: '',
    newValue: 0,
    oldValue: 0,
    percentChange: 0,
}));

const KPITiles = ({
    tiles,
    loading,
    onTileRemove,
    showKpiPercentage,
    kpiTileCharLimit,
    decimalForNonPercentage,
    decimalForPercentage,
}: KPITileProps) => {
    const tilesData = loading ? emptyLoadingTiles : tiles;

    return (
        <div
            className={` flex gap-4 pb-3 overflow-y-scroll greyBackgroundAlt m-2 text-center rounded px-2`}
            id="price-analytics-kpi-tiles"
        >
            {tiles.length === 0 && !loading ? (
                <div className="text-fontGreyAlt font-lg text-center w-full ">Select KPIs to view here.</div>
            ) : (
                <>
                    {tilesData.map((item: KPITileItem, index) => (
                        <KPITile
                            key={index}
                            kpiTile={item}
                            loading={loading}
                            showPercentage={showKpiPercentage}
                            onTileRemove={onTileRemove}
                            kpiTileCharLimit={kpiTileCharLimit}
                            decimalForNonPercentage={decimalForNonPercentage}
                            decimalForPercentage={decimalForPercentage}
                        />
                    ))}
                </>
            )}
        </div>
    );
};

export default KPITiles;
